import "./SingleProduct.scss";
import {
    FaFacebook,
    FaInstagram,
    FaTwitter,
    FaLinkedin,
    FaWhatsapp,
    FaCartPlus
} from "react-icons/fa"
import RelatedProducts from "../SingleProduct/RelatedProducts/RelatedProducts"
import prod from "../../assets/products/earbuds-prod-1.webp"
const SingleProduct = () => {
    return <div className="single-product-main-content">
        <div className="layout">
            <div className="single-product-page">
                <div className="left">
                    <img src={prod} alt="" />
                </div>
                <div className="right">
                    <span className="name">Product Name</span>
                    <span className="price">&#8377;499</span>
                    <span className="desc">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis, ad nisi? Obcaecati libero ducimus eveniet quod, sint cumque, odit iste illum nulla quibusdam a, distinctio laboriosam dicta voluptate delectus veritatis dignissimos? Beatae, modi? Aut nihil dolor architecto sequi voluptate in ipsam amet, commodi, nulla distinctio ipsum recusandae odit facere sapiente!</span>
                <div className="cart-buttons">
                    <div className="quantity-buttons">
                        <span>-</span>
                        <span>5</span>
                        <span>+</span>
                    </div>
                    <button className="add-to-cart-button">
                        <FaCartPlus/>
                        ADD TO CART
                    </button>
                </div>
                <span className="divider"/>
                <div className="info-item">
                    <span className="text-bold">
                        Category:
                        <span>Headphones</span>
                    </span>
                    <span className="text-bold">
                        Share:
                        <span className="social-icons">
                            <FaFacebook size={16}/>
                            <FaInstagram size={16}/>
                            <FaWhatsapp size={16}/>
                            <FaLinkedin size={16}/>
                            <FaTwitter size={16}/>
                        </span>
                    </span> 
                    
                </div>
                </div>
            </div>
            <RelatedProducts/>
        </div>
    </div>;
};

export default SingleProduct;
